import Anchor from "./magics/anchor";
import DialogTeleport from "./magics/dialog_teleport";
import Menu from "./directives/menu";
import PopoverContextZone from "./directives/popover_context_zone";
import SelfDestruct from "./directives/self_destruct";
import Tooltip from "./directives/tooltip";
import SlideOutTransition from "./directives/slide_out_transition";
import AutoComplete from "./components/auto_complete";
import Dropdown from "./components/dropdown";
import Combobox from "./components/combobox";
import DataGrid from "./components/data_grid";
import Dialog from "./components/dialog";
import MultiSelect from "./components/multi_select";
import Notification from "./components/notification";
import Popover from "./components/popover";
import focus from "@alpinejs/focus";
import Validate from "./plugins/form_validation";

import "./lib/request_interceptors";
export { registerClioUITurboStreamActions } from "./turbo_stream_actions";
export {
  handleRowContextMenu,
  POPOVER_TRIGGER_SELECTOR,
} from "./components/data_grid/context_menu";

export { Anchor, SelfDestruct, Tooltip };

export default function (Alpine) {
  Alpine.plugin(focus);
  Alpine.plugin(Validate);
  Alpine.magic("anchor", Anchor);
  Alpine.magic("dialogTeleport", DialogTeleport);
  Alpine.directive("menu", Menu);
  Alpine.directive("popover-context-zone", PopoverContextZone);
  Alpine.directive("self-destruct", SelfDestruct);
  Alpine.directive("tooltip", Tooltip);
  Alpine.directive("slide-out-transition", SlideOutTransition);
  Alpine.data("autoComplete", AutoComplete);
  Alpine.data("dropdown", Dropdown);
  Alpine.data("combobox", Combobox);
  Alpine.data("dataGrid", DataGrid);
  Alpine.data("dialog", Dialog);
  Alpine.data("notification", Notification);
  Alpine.data("multiSelect", MultiSelect);
  Alpine.data("popover", Popover);
}
